<template>
  <div
    class="lg:px-12 md:px-12 lg:py-12 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20 tabs"
  >
    <b-card no-body>
      <b-tabs pills class="custtabs" card>
        <b-tab title="Poetry" active @click="getTabName('Poetry')"
          ><b-card-text
            ><Poetry
              @getShareWorks="getShareWorks"
              @poetryPage="getPoetryPage" /></b-card-text
        ></b-tab>
        <b-tab title="Photo" @click="getTabName('Photo')"
          ><b-card-text><Photos @photosPage="getPage" /></b-card-text
        ></b-tab>
        <b-tab title="Video" @click="getTabName('Video')"
          ><b-card-text
            ><Video
              @getShareWorks="getShareWorks"
              @videoPage="getPage" /></b-card-text
        ></b-tab>
        <!-- <b-tab title="Prose" @click="getTabName('Prose')"
          ><b-card-text
            ><Prose
              @getShareWorks="getShareWorks"
              @videoPage="getPage" /></b-card-text
        ></b-tab> -->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Poetry from "./Poetry.vue";
import Photos from "./Photos.vue";
import Video from "./Video.vue";
import Prose from "./Prose.vue";
export default {
  components: {
    Poetry,
    Photos,
    Video,
    Prose,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    getPage() {},
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    getTabName(name) {
      this.$emit("name", name);
      // console.log(name);
    },
    getPoetryPage(value) {
      this.$emit("page", value);
    },
    getReadMore(value) {
      this.$emit("read", value);
    },
    getShareWorks(name) {
      this.$emit("getShareWorks", name);
    },
  },
};
</script>

<style>
.tabs .card-header {
  display: flex;
  justify-content: center;
}
.custtabs .nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #4f0a4b;
  font-weight: 500;
  font-size: 18px;
  border-bottom: 1px solid;
  background-color: #fff;
  box-shadow: none !important;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  border-radius: none !important;
}
.custtabs .nav-pills .nav-link {
  border-radius: 0px !important;
}
</style>
